module.exports = __webpack_public_path__ + "img/2x.732d5a8.jpg";